import { combineReducers } from 'redux';

import { commonStateReducer } from '@gts-common/client';
import { appReducer } from './app';

export const rootReducer = combineReducers({
  app: appReducer,
  common: commonStateReducer,
});
